<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">계약관리</span>
            <span class="txt">핏투데이케어에 가입한 업체 계약 및 결제정보 등록, 수정, 삭제가 가능합니다.</span>
        </div>

        <div class="com-table-wrap">
            <span class="top-title">
                <span class="title">{{ centerInfo.centerName }} 계약내역</span>
                <a class="com-btn gray" href="/madmin/business/contract/list">목록</a>
            </span>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table class="com-table">
                <colgroup>
                    <col style="width: 124px" />
                    <col style="width: 100px" />
                    <col style="width: 200px" />
                    <col style="width: 400px" />
                    <col style="width: 132px" />
                    <col style="width: 280px" />
                    <col style="width: 200px" />
                    <col style="width: 100px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>계약일</button>
                        </th>
                        <th>
                            <button>계약유형</button>
                        </th>
                        <th>
                            <button>항목</button>
                        </th>
                        <th>
                            <button>서비스명</button>
                        </th>
                        <th></th>
                        <th>
                            <button>사용기간</button>
                        </th>
                        <th>
                            <button>계약금액</button>
                        </th>
                        <th>
                            <button>계약상태</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(c, index) in contractList" :key="index">
                        <td v-if="c.rowspan > 0" :rowspan="c.rowspan">
                            <a :href="`/madmin/business/contract/edit/${c.cp_ft_contract_id}`">
                                {{ c.cp_contract_dt | timestampFilter }}
                            </a>
                        </td>
                        <td>{{ c.cp_ft_prod_type_cd === 'P' ? getContractTypeString(c.cp_contract_type_cd) : '' }}</td>
                        <td>{{ getProductTypeString(c.cp_ft_prod_type_cd) }}</td>
                        <td>{{ c.cp_ft_prod_nm }}</td>
                        <td>
                            <a
                                v-if="c.cp_ft_prod_type_cd === 'P' || c.cp_ft_prod_type_cd === 'M'"
                                :href="`/madmin/business/contract/extension/${c.cp_ft_contract_id}/${c.cp_ft_prod_id}`"
                                class="com-btn-small blue"
                            >
                                연장
                            </a>
                            <a
                                v-if="c.cp_contract_status_cd === 'O'"
                                :href="`/madmin/business/contract/refund/${c.cp_ft_contract_id}/${c.cp_ft_prod_id}`"
                                class="com-btn-small red"
                            >
                                환불
                            </a>
                        </td>
                        <td>
                            <span v-if="c.cp_ft_prod_type_cd === 'P' || c.cp_ft_prod_type_cd === 'M'" class="info-line">
                                <span>
                                    {{ c.cp_contract_start_dt | timestampFilter }} ~
                                    {{ c.cp_contract_end_dt | timestampFilter }}
                                </span>
                                <span v-if="getDaysDiff(c.cp_contract_end_dt) >= 0" class="black">
                                    {{ getDaysDiff(c.cp_contract_end_dt) }} 일 남음
                                </span>
                                <span v-else class="red">사용종료</span>
                            </span>
                        </td>
                        <td>
                            <span class="info-line">
                                <span>{{ c.cp_ft_prod_buy_price | numberFormatFilter }}원</span>
                                <span v-if="c.cp_ret_yn" class="red">
                                    ({{ c.cp_ret_exec_dt | timestampFilter }} 환불
                                    {{ c.cp_ret_price | numberFormatFilter }}원)
                                </span>
                            </span>
                        </td>
                        <td>{{ getContractStatusString(c.cp_contract_status_cd) }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import { Utils } from '@/assets/js/utils';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'businessContractDetail',
    props: {},
    computed: {},
    data() {
        return {
            today: moment(),
            isLoading: false,
            centerId: this.$route.params.id,
            centerInfo: {},
            contractList: [],
            searchStr: '',
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            pagingInfo: { ...pagingInfo },
        };
    },
    mounted() {
        this.getCenterInfo();
        this.onSearchList();
    },
    methods: {
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
                console.log('===> Success Loading : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getContractProduct();
                this.setPageParams(data);
                this.contractList = data.items;
                this.setContractGroupCount();
                this.isLoading = false;
                console.log('===> Success Loading : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        getContractProduct() {
            return api.get(`/admin/api/ft/contract/contract-product/center/${this.centerId}`, {
                params: {
                    searchStr: this.searchStr,
                    ...this.pagingInfo,
                },
            });
        },
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },
        getContractTypeString(contractType) {
            let ret = '';
            switch (contractType) {
                case 'M':
                    ret = '월 결제';
                    break;
                case 'P':
                    ret = '선 결제';
                    break;
            }
            return ret;
        },
        getProductTypeString(productType) {
            let ret = '';
            switch (productType) {
                case 'P':
                    ret = '프로그램';
                    break;
                case 'M':
                    ret = '문자서비스';
                    break;
                case 'B':
                    ret = '부가서비스';
                    break;
            }
            return ret;
        },
        getContractStatusString(contractStatus) {
            let ret = '';
            switch (contractStatus) {
                case 'O':
                    ret = '유효';
                    break;
                case 'X':
                    ret = '종료';
                    break;
            }
            return ret;
        },
        getDaysDiff(d) {
            const t = moment(d);
            const rem = moment.duration(t.diff(this.today)).asDays();

            return Math.floor(rem);
        },
        setContractGroupCount() {
            const { contractList } = this;

            if (Utils.isEmpty(contractList) || contractList.length == 0) {
                return false;
            }

            // 여러개의 상품이 동일한 계약인 경우 첫번째 컬럼을 머지하기 위함
            let i = 0;
            const rowspan = 1;
            const len = contractList.length - 1;
            let parentsRow = contractList[i];
            parentsRow.rowspan = 1;

            if (len < 1) {
                // 데이터가 하나인 경우
                return;
            }

            do {
                i++;

                if (parentsRow.cp_ft_contract_id === contractList[i].cp_ft_contract_id) {
                    contractList[i].rowspan = 0;
                    parentsRow.rowspan++;
                } else {
                    parentsRow = contractList[i];
                    parentsRow.rowspan = 1;
                }
            } while (i < len);

            console.log(contractList);
        },
    },
};
</script>
<style lang="scss"></style>
